import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="zigzag"></div>
      
      <div className="about-content">
        <div className="about-text">
          <h2>OUR STORY</h2>
          <div className="ornament-line">
            <span>◆</span>
            <span>●</span>
            <span>◆</span>
          </div>
          <p>
            Me Decade is a surface pattern design studio that celebrates the bold geometric 
            elegance of the Art Deco movement. Our patterns blend vintage glamour with 
            contemporary aesthetics, creating distinctive designs for modern spaces.
          </p>
          <p>
            From childhood, I was always drawn to the tactile world of textures and patterns. 
            The intricate details and geometric precision of vintage jewelry became a profound 
            inspiration, influencing how I see patterns in architecture and design. Each piece 
            of jewelry told a story through its arrangement of shapes and textures - a principle 
            that now guides every pattern I create.
          </p>
          <p>
            Each pattern is carefully crafted to bring the sophisticated luxury of the 
            roaring twenties into today's interiors, products, and brands, transforming 
            architectural inspiration into wearable and livable art.
          </p>
          <div className="values">
            <div className="value">
              <span className="value-icon">◆</span>
              <h3>CRAFTSMANSHIP</h3>
            </div>
            <div className="value">
              <span className="value-icon">●</span>
              <h3>TIMELESS DESIGN</h3>
            </div>
            <div className="value">
              <span className="value-icon">▲</span>
              <h3>ARTISTIC EXCELLENCE</h3>
            </div>
          </div>
        </div>
        
        <div className="about-visual">
          <div className="geometric-decoration">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>
            <div className="triangle triangle-1"></div>
            <div className="triangle triangle-2"></div>
          </div>
        </div>
      </div>
      
      <div className="zigzag"></div>
    </section>
  );
};

export default About;